
import Live3Sc from "../../components/live3/sc/Live3Sc";
import { useSocket } from "../../helpers/socket";

const Live3SCPage = () => {
    const { socket } = useSocket({});
    return <Live3Sc socket={socket} />
}
export default Live3SCPage;